import { GENDER, MARITAL } from "../../../../values/dropdownItems";

interface DriverInfo {
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  gender?: string;
  marital?: string;
  carSystem?: string;
  carColor?: string;
  companyName?: string;
  address?: string;
}

const DriverInfoMap = ({
  firstName,
  lastName,
  phoneNumber,
  gender,
  marital,
  carSystem,
  carColor,
  companyName,
  address,
}: DriverInfo) => {
  return (
    <div className="description">
      {(firstName || lastName) && (
        <p>
          <i className="fa-light fa-user"></i>
          {(firstName ? firstName : "") + " " + (lastName ? lastName : "")}{" "}
          {phoneNumber && phoneNumber}
        </p>
      )}{" "}
      {gender && (
        <p>
          <i className="fal fa-venus-mars"></i>
          {GENDER.find((item) => item.value === gender)?.name}{" "}
          {marital && MARITAL.find((item: any) => item.value === marital)?.name}
        </p>
      )}
      {(carSystem || carColor) && (
        <p>
          <i className="fa-light fa-car-side"></i>
          {carSystem + " " + carColor}{" "}
        </p>
      )}
      {companyName && (
        <p>
          <i className="fa-light fa-building"></i>
          {companyName}{" "}
        </p>
      )}
      {address && (
        <p>
          <i className="fa-light fa-location-dot"></i> {address}{" "}
        </p>
      )}
    </div>
  );
};

export default DriverInfoMap;
